<i18n>
{
  "ru": {
    "cart": "Корзина"
  },
  "uk": {
    "cart": "Кошик"
  }
}
</i18n>

<template>
  <div class="col-md-2" id="cart">
    <router-link
      :to="'/' + locale + '/cart'"
      id="cart-total"
      v-if="$store.state.cart.length > 0"
    >
      <div class="mini_cart hover_icon">
        <div class="cart_holder">
          <span class="cart-text"
            >{{ $t("cart") }}&nbsp;&nbsp;&nbsp;&nbsp;</span
          >
          <i class="icon-basket light_color"></i>&nbsp;
          <span id="cart_count" class="count">{{
            $store.state.cartCount
          }}</span>
          <span id="total_price" class="total">{{
            $store.state.fullAmount
          }}</span>
        </div>
      </div>
    </router-link>
    <div id="cart_content_ajax" class="content" v-if="$route.name !== 'cart'">
      <div v-if="$store.state.cart.length == 0" class="empty main_font">
        Корзина пустая!
      </div>
      <div v-else id="no-empty" class="main_font">
        <div class="mini-cart-info">
          <ul>
            <li
              class="flex"
              v-for="(item, index) in $store.state.cart"
              :key="index"
            >
              <img :src="item.images[0]" />
              <div class="desc">
                <span
                  >{{ item.name[locale] }}
                  <small>(Размер: {{ item.size.name[locale] }})</small></span
                >
                <span
                  >{{ item.quantity }} * {{ item.price }} =
                  {{ totalPrice(item) }} грн.</span
                >
              </div>
              <a
                class="clear-mini-cart"
                href="#"
                @click.prevent="removeFromCart(item)"
                >&times;</a
              >
            </li>
          </ul>
        </div>
        <div class="checkout">
          <div class="additional pull-left">
            <p>
              Всего:
              <span class="as-total">{{ $store.state.fullAmount }} грн.</span>
            </p>
          </div>
          <router-link
            :to="'/' + locale + '/cart'"
            class="button btn btn-primary btn-checkout"
            >Оформить заказ</router-link
          >
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      locale: this.$route.params.locale
    };
  },
  methods: {
    totalPrice(item) {
      return item.price * item.quantity;
    },
    removeFromCart(item) {
      this.$store.commit("removeFromCart", item);
    }
  },
  watch: {
    $route(to) {
      this.locale = to.params.locale;
    }
  }
};
</script>

<style scoped>
@font-face {
  font-family: "fontello";
  src: url("../assets/fonts/fontello.eot?60124471");
  src: url("../assets/fonts/fontello.eot?60124471#iefix")
      format("embedded-opentype"),
    url("../assets/fonts/fontello.woff?60124471") format("woff"),
    url("../assets/fonts/fontello.ttf?60124471") format("truetype"),
    url("../assets/fonts/fontello.svg?60124471#fontello") format("svg");
  font-weight: normal;
  font-style: normal;
}
[class^="icon-"]:before,
[class*=" icon-"]:before {
  font-family: "fontello";
  font-style: normal;
  font-weight: normal;
  display: inline-block;
  text-align: center;
  font-variant: normal;
  text-transform: none;
  line-height: 1em;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

#cart {
  display: inline-block;
  position: relative;
  vertical-align: middle;
}
.mini_cart {
  border: 1px solid #eaeaea;
  position: relative;
  z-index: 2;
  border-radius: 0px;
  text-align: left;
  font-weight: bold;
  padding: 5px 10px 4px;
  color: #346296;
  line-height: 18px;
  background: #ffffff;
}
.mini_cart .cart_holder {
  position: relative;
  height: 42px;
  padding-left: 55px;
}
.mini_cart .cart_holder .cart-text {
  display: none;
}
.mini_cart .icon-basket {
  font-size: 42px;
  position: absolute;
  left: 0px;
  top: 0;
}
.mini_cart .icon-basket:before {
  line-height: 40px;
}
.mini_cart .count,
.wishlist_compare.icons .count {
  position: absolute;
  font-weight: normal;
  line-height: normal;
  width: 20px;
  height: 20px;
  background: #ffffff;
  border: 1px solid #b2b2b2;
  color: #346296;
  display: block;
  text-align: center;
  border-radius: 100%;
  line-height: 20px;
  font-size: 12px;
}
.mini_cart .count {
  top: 21px;
  left: 31px;
}
.mini_cart .total {
  font-size: 18px;
  line-height: 28px;
  color: #346296;
}
.mini_cart .icon-down-dir {
  margin-left: 2px;
}
.mini_cart {
  border-radius: 0px;
  border-color: #eaeaea;
  margin-left: -1px;
  padding: 6px 22px 6px 9px;
  height: 55px;
}
.header4 .cart_holder {
  padding-left: 54px;
}
.header4 .mini_cart {
  padding: 11px 35px 11px 10px;
  height: 66px;
}

/* Mini cart dropdown */
#cart .content {
  position: absolute;
  text-align: left;
  left: auto;
  right: 0;
  margin-top: -1px;
  border: 1px solid #eaeaea;
  border-radius: 3px;
  background: #ffffff;
  width: 265px;
  color: #777777;
  font-size: 14px;
  clear: both;
  padding: 10px;
  min-height: 40px;
  margin-top: 15px;
  opacity: 0;
  visibility: hidden;
  transition: margin-top 300ms, opacity 200ms, visibility 200ms;
  white-space: normal;
  z-index: 1051;
}
#cart .content {
  border-radius: 0;
}
#cart:hover .content {
  margin-top: 1px;
  opacity: 1;
  visibility: visible;
  transition: margin-top 400ms, opacity 300ms;
}
#cart:hover .content {
  margin-top: -1px;
}
#cart table {
  border-collapse: collapse;
}
#cart table .fa-times {
  color: #777777;
}
#cart table .fa-times:hover {
  color: #333333;
}
#cart td {
  vertical-align: top;
  padding: 15px 20px;
  font-size: 13px;
}
#cart td.border {
  border-bottom: 1px solid #eaeaea;
}
#cart td a {
  display: block;
  margin-bottom: 3px;
}
#cart .image {
  text-align: left;
  width: auto;
  padding: 15px 5px 15px 20px;
}
#cart .image img {
  margin: 0px;
  display: block;
  max-width: 60px;
}
#cart .name {
  padding: 15px 5px;
  width: 100%;
}
#cart .name small {
  color: #595959;
}
#cart .voucher {
  text-align: left;
  padding: 1px 15px;
}
#cart .mini-cart-total {
  padding: 10px 0;
}
.mini-cart-total table {
  text-align: left;
  display: inline-block;
}

#cart .mini-cart-total td {
  padding: 4px 0 0 20px;
  font-size: 12px;
}
#cart .mini-cart-total .sums {
  white-space: nowrap;
}
#cart .mini-cart-total tr:last-child td {
  font-size: 16px;
  color: #333333;
  font-weight: bold;
}
#cart .checkoutbuttons {
  padding: 10px 20px;
  border-top: 1px solid #eaeaea;
}
#cart .empty {
  height: 70px;
  padding-top: 25px;
  text-align: center;
  font-size: 13px;
}
.mini-cart-info img {
  height: 50px;
  margin-right: 5px;
}
.mini-cart-info .desc span:first-child {
  font-weight: bold;
}
#cart .additional {
  margin-top: 10px;
}
#cart .additional p {
  margin-bottom: 0;
}
.mini-cart-info .desc span {
  display: block;
}
.mini-cart-info ul {
  margin: 0;
  padding: 0;
}
.icon-basket:before {
  content: "\e800";
} /* '' */
.icon-search:before {
  content: "\e801";
} /* '' */
.icon-down-dir:before {
  content: "\e802";
} /* '' */
.icon-resize-small:before {
  content: "\e803";
} /* '' */
.icon-note:before {
  content: "\e804";
} /* '' */
.icon-cog:before {
  content: "\e805";
} /* '' */
.icon-params:before {
  content: "\e806";
} /* '' */
.icon-calendar:before {
  content: "\e807";
} /* '' */
.icon-sound:before {
  content: "\e808";
} /* '' */
.icon-clock:before {
  content: "\e809";
} /* '' */
.icon-lightbulb:before {
  content: "\e80a";
} /* '' */
.icon-tv:before {
  content: "\e80b";
} /* '' */
.icon-beaker:before {
  content: "\e80c";
} /* '' */
.icon-truck:before {
  content: "\e80d";
} /* '' */
.icon-money:before {
  content: "\e80e";
} /* '' */
.icon-food:before {
  content: "\e80f";
} /* '' */
.icon-shop:before {
  content: "\e810";
} /* '' */
.icon-diamond:before {
  content: "\e811";
} /* '' */
.icon-t-shirt:before {
  content: "\e812";
} /* '' */
.icon-wallet:before {
  content: "\e813";
} /* '' */
.icon-music:before {
  content: "\e814";
} /* '' */
.icon-search-1:before {
  content: "\e815";
} /* '' */
.icon-mail:before {
  content: "\e816";
} /* '' */
.icon-heart:before {
  content: "\e817";
} /* '' */
.icon-star:before {
  content: "\e818";
} /* '' */
.icon-user:before {
  content: "\e819";
} /* '' */
.icon-videocam:before {
  content: "\e81a";
} /* '' */
.icon-camera:before {
  content: "\e81b";
} /* '' */
.icon-photo:before {
  content: "\e81c";
} /* '' */
.icon-attach:before {
  content: "\e81d";
} /* '' */
.icon-lock:before {
  content: "\e81e";
} /* '' */
.icon-eye:before {
  content: "\e81f";
} /* '' */
.icon-desktop:before {
  content: "\e820";
} /* '' */
.icon-mobile:before {
  content: "\e821";
} /* '' */
.icon-cd:before {
  content: "\e822";
} /* '' */
.icon-inbox:before {
  content: "\e823";
} /* '' */
.icon-globe:before {
  content: "\e824";
} /* '' */
.icon-tag:before {
  content: "\e825";
} /* '' */
.icon-thumbs-up:before {
  content: "\e826";
} /* '' */
.icon-cloud:before {
  content: "\e827";
} /* '' */
.icon-paper-plane:before {
  content: "\e828";
} /* '' */
.icon-pencil:before {
  content: "\e829";
} /* '' */
.icon-comment:before {
  content: "\e82a";
} /* '' */
.icon-location:before {
  content: "\e82b";
} /* '' */
.icon-cup:before {
  content: "\e82c";
} /* '' */
.icon-trash:before {
  content: "\e82d";
} /* '' */
.icon-doc:before {
  content: "\e82e";
} /* '' */
.icon-key:before {
  content: "\e82f";
} /* '' */
.icon-database:before {
  content: "\e830";
} /* '' */
.icon-megaphone:before {
  content: "\e831";
} /* '' */
.icon-graduation-cap:before {
  content: "\e832";
} /* '' */
.icon-fire:before {
  content: "\e833";
} /* '' */
.icon-menu:before {
  content: "\e834";
} /* '' */
@media screen and (max-width: 1280px) {
  .mini_cart {
    padding: 0;
  }
  .mini_cart .total {
    display: block;
  }
  .mini_cart .icon-basket {
    left: 10px;
    top: 7px;
  }
}
@media screen and (max-width: 1280px) {
  #cart {
    padding: 0;
    width: 60%;
    margin: 10px auto;
  }
}
</style>
